import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ManageProductAvailabilityPage } from "~/pages/settings/organisations/organisation/settings/manage-product-availability-page";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/settings/product-availability",
)({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.productAvailability") }],
  }),
  component: ManageProductAvailabilityPage,
});
